"use client";

import { useState } from "react";
import { RiCalendarScheduleLine } from "react-icons/ri";
import IconBox from "../common/IconBox";
import ShadowCard from "../common/ShadowCard";
import Button from "../ui/Button";
import ScheduleCallModal from "./ScheduleCallModal";

export default function ContactSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="flex items-center justify-center py-20 md:min-h-screen md:py-0">
      <div className="w-full px-5 md:px-25">
        <ShadowCard className="group relative flex flex-col items-start overflow-hidden p-8 md:p-10">
          {/* Video Background */}
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 -z-10 h-full w-full object-cover"
          >
            <source src="/contact-bg.mp4" type="video/mp4" />
          </video>

          {/* Gradient overlay — opaque on left, transparent on right */}
          <div className="pointer-events-none absolute inset-0 bg-linear-to-r from-black/85 via-black/10 to-transparent" />

          {/* Red accent gradient — top-right, subtle */}
          {/* <div className="pointer-events-none absolute top-0 right-0 h-full w-[60%] bg-linear-to-bl from-red-600/20 via-transparent to-transparent opacity-50" /> */}

          {/* Icon Box */}
          <IconBox icon={RiCalendarScheduleLine} />

          <div className="relative z-10 max-w-4xl pt-2.5">
            <h2 className="font-goldman mb-5 text-[2rem] leading-tight font-bold text-white uppercase md:text-[48px]">
              Ready to increase your profit with no cost to you?
            </h2>
            <p className="font-raleway mb-10 text-base font-normal text-white md:text-[2rem]">
              Schedule a FREE Consultation Today!
            </p>
          </div>

          <Button
            variant="gradient"
            className="relative z-10"
            onClick={() => setIsModalOpen(true)}
          >
            Schedule a Call
          </Button>
        </ShadowCard>
      </div>

      <ScheduleCallModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
